import { RootStore } from './rootStore';
import { action, decorate, observable } from 'mobx';
import { Message } from './models/messageModels';
import { v4 as uuidv4 } from 'uuid';


export class UIStateStore {

    messages: Message[] = [];
    modalOpen: boolean = false;

    private rootStore: RootStore;
    private modalContent: any = undefined;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        //makeAutoObservable(this)
    }

    getModalContent() {
        return this.modalContent;
    }

    setModalContent(modalContent: any) {
        this.modalContent = modalContent;
    }

    setModalOpen(modalOpen: boolean) {
        this.modalOpen = modalOpen;
    }

    clearModal(){
        this.modalOpen = false;
        this.modalContent = undefined;
    }

    // Example usage of snackbar messages

    // uiStateStore.pushMessage("This is a regular success message.", 'success');
    // uiStateStore.pushMessage("This is a regular info message.", 'info');
    // uiStateStore.pushMessage("This is a regular warning message.", 'warning');
    // uiStateStore.pushMessage("This is a regular error message.", 'error');
    // uiStateStore.pushMessage("This is a regular persistent error message.", 'error', true);
    // uiStateStore.pushMessage("This is a regular message.", '');
    // uiStateStore.pushMessage("This is a regular info message.");

    pushMessage(content: string, kind: string = 'info', persistent: boolean = false, action: any = null) {
        this.messages.push({
            internalKey: uuidv4(),
            persistent: persistent,
            content: content,
            kind: kind,
            action: action
        } as Message);
    }
}

decorate(UIStateStore, {
    messages: observable,
    modalOpen: observable,

    setModalContent: action,
    setModalOpen: action,
    pushMessage: action,
    clearModal: action
});